import { useState, useEffect } from "react";

// import MainMenuTwoAmp from '../MainMenuTwoAmp/MainMenuTwoAmp';
import { getEndpoint, getUrl, getImageUrl, fetchAnchorValue } from "../../../common/utils";
// import DrawerComponentTwoAmp from "../SidebarTwoAmp/DrawerComponentTwoAmp";
import bcrypt from 'bcryptjs-react';
import './HeaderThreeAmp.css';
//import IconButton from '@mui/material/IconButton';
//import MenuIcon from '@mui/icons-material/Menu';
import SidebarComponent from "../../SidebarComponent";
import { ENDUSER_PAGE, PAGEBUILDER_URLS } from '../../Common/Constant';
import HomeIcon from '@mui/icons-material/Home';


HeaderThreeAmp.version = 1000;
Object.defineProperty(HeaderThreeAmp, 'name', {
  writable: true,
  value: 'HeaderThreeAmp'
});
// export const config = { amp: true }
export function HeaderThreeAmp(props: any) {
  const [menuItems, setMenuItems] = useState<any>([]);
  const [headerData, setHeaderData] = useState<any>({});
  const [showMainMenu, setMainMenu] = useState(false);
  const [toogleMenuData, setToggleMenuData] = useState<any>([]);
  // const [searchValue, setSearchValue, ] = useState<any>("");

  let REQUEST_URL: any = null;
  if (props && props.REQUEST_URL) {
    REQUEST_URL = props.REQUEST_URL;
  }


  const {
    onClick,
    isSticky,
    /*MSID*/
    CONSTANTS,
    anchorLinksValue
  } = props;

  const endpoint = getEndpoint(props, "MAIN");
  const headerMenuEndpoint = getEndpoint(props, "HEADER_MENU_API");
  const togglerEndpoint = getEndpoint(props, "TOGGLER_MENU_API");

  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj || !headerMenuEndpoint.isSSR || !headerMenuEndpoint.SSRDataObj) {
      fetchComponentData();
    }
  }, []);

  if (endpoint.isSSR && endpoint.SSRDataObj && (!headerData || !Object.keys(headerData).length)) {
    setHeaderData(endpoint.SSRDataObj);

    if (isSticky) {
      setTimeout(() => {
        if (typeof document !== 'undefined' && undefined !== document && document && document.getElementsByTagName("header") && document.getElementsByTagName("header")[0])
          document.getElementsByTagName("header")[0].classList.add("sticky");
      })
    }
  }

  if (headerMenuEndpoint.isSSR && headerMenuEndpoint.SSRDataObj && headerMenuEndpoint.SSRDataObj.length && (!menuItems || !menuItems.length)) {
    setMenuItems(headerMenuEndpoint.SSRDataObj);
  }

  if (togglerEndpoint.isSSR && togglerEndpoint.SSRDataObj && togglerEndpoint.SSRDataObj.length && (!toogleMenuData || !toogleMenuData.length)) {
    setToggleMenuData(togglerEndpoint.SSRDataObj);
  }

  // const toggleMainMenu = () => {
  //   if (toogleMenuData.length == 0) {
  //     getToggleMenuData();
  //   } else {
  //     setMainMenu(!showMainMenu);
  //   }
  // }

  // const getToggleMenuData = () => {
  //   let toggleMenuAPIurl = getUrl(props, 0, false, "TOGGLER_MENU_API", true)

  //   fetch(toggleMenuAPIurl).then((response) => response.json())
  //     .then((val) => setToggleMenuData(val))
  //     .then(() => setMainMenu(true))
  // }

  const fetchComponentData = () => {
    const { ENDPOINTS } = props;
    let headerAPI = getUrl(props, 0, false, "MAIN", true, ENDPOINTS[0].queryParams.websiteId, ENDPOINTS[0].queryParams.clientId)
    let menuAPIurl = getUrl(props, 0, false, "HEADER_MENU_API", true)
    let headerString = `?` + headerAPI.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const customHeaders = {
      'Content-Type': 'application/json',
      'p-nonce': headerString
    };

    let headerString_menuAPIurl = '?' + menuAPIurl.split("?")[1];
    headerString_menuAPIurl = bcrypt.hashSync(headerString_menuAPIurl, 6);
    const headers_menuAPIurl = { 'p-nonce': headerString_menuAPIurl };

    Promise.all([
      fetch(headerAPI, {
        method: 'GET',
        headers: customHeaders,
        credentials: "include",
      }).then((response) => response.json()),

      fetch(menuAPIurl, { headers: headers_menuAPIurl }).then((response) => response.json()),
    ])

      .then(([result1, result2]) => {
        // Handle the results individually
        setHeaderData(result1);
        setMenuItems(result2);
      })
      .catch((error) => {
        // Handle errors here
        console.error('Error fetching data:', error);
      });
  }

  const checkIfActive = (name: string) => {

    if (typeof window !== 'undefined' && window && window.location && window.location.pathname) {
      const pathName = window.location.pathname.toLowerCase();
      const nameLowerCase = name.toString().toLowerCase();

      if (pathName.indexOf("/" + nameLowerCase + "/") >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }



  const renderTopBar = () => {
    return <div className="header-left themeThreeHeaderAmp">
      <div className="sidebar-menu-icon">
        {/* <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2 }} onClick={()=> setMainMenu(true)}>
          <MenuIcon />
        </IconButton> */}
        {typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)) ? '' :
          <SidebarComponent menuItems={menuItems} />
        }
      </div>
      <div id="themeTwoHeaderAmpLogo">
        <a href="/" aria-label="logo" target={fetchAnchorValue(anchorLinksValue, "/")} className="main-logo themeTwoHeaderAmpMainLogo">
          {headerData.mainLogo && <img src={getImageUrl(headerData.mainLogo, "422424", 300, undefined, "", false, props.CONSTANTS)} alt="logo" width="auto" height="auto" />}
        </a>
      </div>
    </div>

  }

  const getMenuData = () => {
    let menuData = menuItems;
    // console.log('menuItems1111111',menuItems)
    if (menuData.length > 0 && menuData.some((item: any) => item.secid === '123')) {

      if (typeof REQUEST_URL !== 'undefined' && REQUEST_URL) {
        const splitPath = REQUEST_URL.split('/');
        const secondLastSegment = splitPath[splitPath.length - 2];
        if (ENDUSER_PAGE.includes(secondLastSegment)) {
          callNavApi(menuData, headerMenuEndpoint.queryParams.hostId);
          menuData = menuData.map((item: any) => {
            if (item.secid === '123') {
              return { ...item, name: <HomeIcon />, key: 123 };
            }
            return item;
          });
        }
      }
    } 


    let data = menuData.map((menuItem: any, index: number) => {
      if (menuItem) {
        let isActive = checkIfActive(menuItem.name);
        // console.log('menuItem11111',menuItem)
        return <a key={'kk_' + index} className={`menuItem testheader3amp ${isActive ? "active" : ""}`} href={menuItem.path} target={fetchAnchorValue(anchorLinksValue, menuItem.path)}>{menuItem.name}
        </a>
      }
    })



    return data;
  }

  function callNavApi(menuData: any, hostId: any) {
    if (typeof REQUEST_URL !== 'undefined' && undefined !== REQUEST_URL && REQUEST_URL) {
      const pathName = REQUEST_URL;
      const pathArray = pathName.split('/');
      let msid = pathArray[pathArray.length - 1];
      msid = msid.split('.')[0];
      const url = `${CONSTANTS.CDS_API}/cds-feed-ext/listing/get/m360?msid=${msid}&fv=1000&hostId=${hostId}&pp=4&cp=1&apiType=nav`;

      let headerString = '?' + url.split("?")[1];
      headerString = bcrypt.hashSync(headerString, 6);
      const headers = { 'p-nonce': headerString };

      const fetch1 = require('sync-fetch');
      const pr = fetch1(url, { headers: headers });
      const statusCode = pr.status;
      let response = [];
      try {
        response = pr.json();
      } catch (error: any) {
        console.error('Error:', error.message);
      }
      if (statusCode === 200) {
        if (response) {
          const firstElement = response.items[0];
          let item = null;
          if (pathArray.includes('articleshow') || pathArray.includes('videoshow') || pathArray.includes('podcast') || pathArray.includes('photoshow') || pathArray.includes('amp_articleshow') || pathArray.includes('amp_photoshow') || pathArray.includes('amp_videoshow')) {
            item = { name: firstElement.hl, secid: '456', path: firstElement.wu, type: 1 }
          } else if (pathArray.includes('articlelist') || pathArray.includes('photolist') || pathArray.includes('videolist') || pathArray.includes('webstorylist') || pathArray.includes('podcastlist')) {
            item = { name: response.title, secid: '456', path: pathName, type: 1 }
          }
          //menuData.unshift(item);
          menuData.splice(1, 0, item);
        }
      }
    }
  }


  // //console.log('menuItems', menuItems)
  // //console.log('toogleMenuData', toogleMenuData)
  return (
    <div className="card_wrapper themeTwoHeaderAmpCardWrapper themeThreeHeaderAmpCardWrapper" onClick={onClick}>
      {renderTopBar()}
      <div className="scrollmenu themeTwoHeaderAmpScrollMenu">
        {getMenuData()}
      </div>
      {showMainMenu && <div id="mySidenav" className="ampSidenav themeTwoHeaderAmpSideNav">
        <div onClick={() => setMainMenu(false)} className="closemenu themeTwoHeaderAmpClose">x</div>
        <ul className="mainsection themeTwoHeaderAmpMainSection testheader3ampul"
          itemType="http://www.schema.org/SiteNavigationElement"
          itemScope={true}>
          {menuItems.map((val: any, index: number) => {
            return (
              <li key={'sidenv-' + index} itemProp="name" content={val.name}>
              {val.name}
              {val.sections && val.sections.length > 0 && (
                <ul className="subsection themeTwoHeaderAmpSubSection testheader3ampul2">
                  {val.sections.map((item: any, index: number) => (
                    <li key={'section-' + index}>{item.name}</li>
                  ))}
                </ul>

              )}
            </li>



            )
          })}


        </ul>
      </div>
      }
      {/* {Object.keys(headerData).length && <MainMenuTwoAmp menuItems={menuItems} domainUrl={defaultDomainUrl} toggleMainMenu={toggleMainMenu} />} */}

    </div>
  );
}